module.exports = __webpack_public_path__ + "static/media/tecno1.3d9ce122.png";